import { render, staticRenderFns } from "./EmployeeInquiry.vue?vue&type=template&id=0b230142&"
import script from "./EmployeeInquiry.vue?vue&type=script&lang=js&"
export * from "./EmployeeInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports